import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import {cloneObject, getParam} from '../utils/utils';

import dsd from "../classes/clsDSD";

import SelectDataSpec from "../components/SelectDataSpec";
import SelectSerialization from "../components/SelectSerialization";

import { Plus, Trash, ArrowUp, ArrowDown } from 'react-bootstrap-icons';

class FormMethodResponse extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            isFailed: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleButton = this.handleButton.bind(this);

        this.dsd = new dsd();
        this.FallBackNavigation = `.`;
    }

    componentDidMount(){

       this.setup();

    }

    componentDidUpdate(prevProps, prevState){
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }
    }
    
    setup(){
        let StateChange = {
            FormData: null,
            MethodResponse: null,
            seq: null,
            idInterface: null,
            onAdd: null,
            onRemove: null,
            onUpdate: null,
            onMoveUp: null,
            onMoveDown: null,
            mode: 'edit'
        }

        StateChange.onAdd = getParam('onAdd', this.props);
        StateChange.onRemove = getParam('onRemove', this.props);
        StateChange.onUpdate = getParam('onUpdate', this.props);
        StateChange.onMoveUp = getParam('onMoveUp', this.props);
        StateChange.onMoveDown = getParam('onMoveDown', this.props);
        StateChange.mode = getParam('mode', this.props) || 'edit';
        StateChange.seq = getParam('seq', this.props);
        StateChange.idInterface = getParam('idInterface', this.props);
        
        StateChange.MethodResponse = getParam('MethodResponse', this.props);
        if (isNull(StateChange.MethodResponse)){
            StateChange.MethodResponse = {};
        }
        
        StateChange.FormData = cloneObject(StateChange.MethodResponse);

        this.setState(StateChange);
    }

    handleButton(event) {
        let StateChange = {};

        switch (event.currentTarget.name){
            case 'btnAdd':
                StateChange.mode = 'edit';

                if (this.state.onAdd){
                    this.state.onAdd();
                    break;
                }
                break;
            case 'btnDelete':
                if (this.state.onRemove){
                    this.state.onRemove(this.state.seq);
                    break;
                }
                break;
            case 'btnUp':
                if (this.state.onMoveUp){
                    this.state.onMoveUp(this.state.seq);
                    break;
                }
                break;
            case 'btnDown':
                if (this.state.onMoveDown){
                    this.state.onMoveDown(this.state.seq);
                    break;
                }
                break;
        }

        this.setState(StateChange);
        event.preventDefault();
    };


    handleChange(event) {
        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let FormData = this.state.FormData;
        FormData[FormFieldName] = FormFieldValue;
        this.setState({FormData: FormData});

        if (this.state.onUpdate){
            this.state.onUpdate(this.state.seq, FormData);
        }
    };


    render() {
        if (!this.state.FormData) {
            return null;
        }

        switch (this.state.mode){
            case 'new':
            case 'edit':
                return (
                        <form>
                            {(() => {
                                switch (this.state.mode) {
                                    case "new": 
                                        return <button name="btnAdd" onClick={this.handleButton}><Plus/></button>;
                                    default:
                                        return(
                                            <PD.Table type="list">
                                                <>
                                                    <PD.Tr>
                                                        <PD.Td>
                                                            <div>
                                                                <div>
                                                                    <button name="btnDelete" onClick={this.handleButton}><Trash/></button>
                                                                </div>
                                                                {this.state.onMoveUp &&
                                                                    <div>
                                                                        <button name="btnUp" onClick={this.handleButton}><ArrowUp/></button>
                                                                    </div>
                                                                }
                                                                {this.state.onMoveDown &&
                                                                    <div>
                                                                        <button name="btnDown" onClick={this.handleButton}><ArrowDown/></button>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </PD.Td>

                                                        <PD.Td>
                                                            <PD.Input label="Status Code" width="4" name="statusCode" value={this.state.FormData.statusCode} onChange={this.handleChange}/>
                                                        </PD.Td>

                                                        <PD.Td>
                                                            <SelectSerialization name="idSerialization" label="Serialization" idInterface={this.state.idInterface} onChange={this.handleChange} value={this.state.FormData.idSerialization}/>
                                                        </PD.Td>

                                                        <PD.Td>
                                                            <PD.Select label='Occurs' name='occurs'  onChange={this.handleChange} value={this.state.FormData.occurs}>
                                                                {
                                                                    this.dsd.model.config.Occurs.map(
                                                                        (occurs, pos) => 
                                                                            {
                                                                                return(
                                                                                    <option key={pos} value={occurs}>{occurs}</option>
                                                                                )
                                                                            }
                                                                    )
                                                                }
                                                            </PD.Select>
                                                        </PD.Td>
                                                
                                                    </PD.Tr>
                                                    <PD.Tr>
                                                        <PD.Td/>
                                                        <PD.Td colSpan='5'>
                                                            <PD.Editor name="description" label='Description' value={this.state.FormData.description} onChange={this.handleChange}/>
                                                        </PD.Td>
                                                    </PD.Tr>
                                                </>
                                            </PD.Table>
                                        )
                                }
                            })()}
                        </form>
                );
            default:
                return null;
        }
    };
};

// Wrap and export
export default function FormMethodResponse_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <FormMethodResponse {...props} navigation={navigation} location={location} params={params} />;
  }
